module.exports = __webpack_public_path__ + "static/media/layer-to-back.c09b81e9.svg";